/**
 * @param {{
 *   requestId?: string | null,
 *   ok: boolean,
 *   error?: { status?: unknown, original?: unknown, message?: unknown },
 * }} outcome
 */
export const buildLastPersist = ({ requestId, ok, error }) => ({
  requestId: requestId ?? null,
  ok,
  status: !ok && typeof error?.status === 'number' ? error.status : null,
  original: ok ? null : error?.original ?? null,
});
